var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tippy",
          rawName: "v-tippy",
          value: { followCursor: true, placement: "bottom-end" },
          expression: "{ followCursor: true, placement: 'bottom-end' }",
        },
      ],
      staticClass: "mic-button",
      class: { active: _vm.active },
      attrs: { content: 'Click or Press CTRL + " for speech to text' },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("keyboard_voice")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }